import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Table from '../../../../../components/Table/Table';
import './RequestHistory.css';
//icons
import editIcon from '../../../../../assets/editIcon.png'
import editInactive from '../../../../../assets/tokens/editInactive.png'
import eyeOn from '../../../../../assets/tokens/eyeOn.png'
import eyeOff from '../../../../../assets/tokens/eyeOff.png'
//services
import { customer } from '../../../../../services/customer';  
//utils
import { formatDate, formatTime } from '../../../../../utils/utils';

const RequestHistory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedRequest, setSelectedRequest] = useState({
    requestFolio: 'Request Folio 1',
    category: 'Category',
    subcategory: 'Subcategory',
    typeOfService: 'Physical',
    date: '17/16/1997',
    time: '10:30 a.m.',
    tokensUsed: '1000',
    status: 'Active'
  });

  const columns = [
    {
      header: 'Request Folio',
      field: 'id'
    },
    {
      header: 'Category',
      field: 'category'
    },
    {
      header: 'Subcategory',
      field: 'subcategory'
    },
    {
      header: 'Type of service',
      field: 'typeOfService'
    },
    {
      header: 'Date',
      field: 'date'
    },
    {
      header: 'Time',
      field: 'time'
    },
    {
      header: 'Number of barter bucks used',
      field: 'tokensUsed'
    },
    {
      header: 'Status',
      field: 'status'
    },
    {
      header: '',
      render: (row) => (
        <button className="edit-btn" onClick={() => handleToggle(row)}>
          <img src={eyeOn} alt="Toggle" />
        </button>
      )
    },
  ];

  const handleToggle = (row) => {
    setSelectedRequest(row);
    navigate(`/customers/request-history/${row.id}`, {
      state: { request: row }
    });
  };

  const fetchRequests = async (page = 1) => {
    try {
      const params = {
        page: page,
        items_per_page: 10
      };
      
      const response = await customer.serviceHistory(id, params);
      if (response.status === 'success') {
        setTotalItems(response.data.total);
        const formattedRequests = response.data.data.sort((a, b) => new Date(b.service.created_at) - new Date(a.service.created_at)).map(request => ({
          ...request,
          status: request.status,
          category: request.service.category.name,
          subcategory: request.service.subcategory.name,
          typeOfService: request.service.service_type,
          tokensUsed: request.service.service_cost,
          date: formatDate(request.service.created_at.split('T')[0]),
          time: formatTime(request.service.created_at)
        }));
        setRequests(formattedRequests);
      }
    } catch (error) {
      console.error('Error fetching requests:', error);
    }
  };

  useEffect(() => {
    fetchRequests(currentPage);
  }, [currentPage, id]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className="request-history">
      <Table
        data={requests}
        columns={columns}
        columnsShare={1}
        itemsPerPage={10}
        currentPage={currentPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default RequestHistory;
